module.exports = __webpack_public_path__ + "static/ruthlene-ba81b793ec6677dc8ea33273222e57ff.svg";